import { createAction, props } from '@ngrx/store';
import { RealEstateObject } from '@immosky/types';

export enum MapResultActions {
  Set = '[Results] Set Map Real Estate Objects',
  Reset = '[Results] Reset Map Real Estate Objects',
}

export const setMapRealEstateObjects = createAction(
  MapResultActions.Set,
  props<{ objects: RealEstateObject[] }>()
);

export const resetMapRealEstateObjects = createAction(MapResultActions.Reset);
